import React, { useEffect, useState } from 'react';
import { useToast } from 'src/context/ToastProvider';
import { Button, Label, Radio } from 'flowbite-react';
import { useUserContext } from 'src/context/UserProvider';
import { useMarkAttendanceMutation } from 'src/hooks/utils/mutations/offlineDriveMutations/useMarkAttendanceMutation.hooks';
import { OfflineDriveCandidateStatus } from 'types';

const DrivePositionsBulkAction = ({
	showModalUi = false,
	bulkSelectedCompanies,
	defaultBulkAction,
}: {
	showModalUi?: boolean;
	bulkSelectedCompanies: string[];
	defaultBulkAction?: string;
}) => {
	const toast = useToast();
	const { selectedDrive } = useUserContext();
	const [localActionSelect, setLocalActionSelect] = useState('');
	const [selectedAction, setSelectedAction] = useState(defaultBulkAction);

	useEffect(() => {
		setSelectedAction(defaultBulkAction);
		setLocalActionSelect(defaultBulkAction || '');
	}, [defaultBulkAction]);

	const markAttendanceMutation = useMarkAttendanceMutation();

	const actions = [
		{
			hide: false,
			id: 'mark-attendance-for-company',
			label: 'Mark Attendance for Company',
			onClick: () => {
				if (!selectedDrive?.value || !bulkSelectedCompanies.length) {
					toast({
						title: 'Drive ID or Company ID is missing',
					});
					return;
				}

				markAttendanceMutation.mutate({
					isCompany: true,
					driveId: selectedDrive?.value,
					companyIds: bulkSelectedCompanies,
					status: OfflineDriveCandidateStatus.PRESENT,
				});
			},
			isProcessing: markAttendanceMutation.isLoading,
		},
	];

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		actions.find(action => action.id === localActionSelect)?.onClick();
	};

	const getBulkActionForm = () => {
		switch (selectedAction) {
			default:
				return (
					<>
						<form onSubmit={handleSubmit} className="pt-3">
							<fieldset
								className="grid grid-cols-2 max-w-md gap-4"
								onChange={e => {
									const target = e.target as HTMLInputElement;
									if (target?.value) {
										setLocalActionSelect(target?.value);
									}
								}}
							>
								{actions?.filter(action => !action?.hide).map((action, index) => (
									<div className="flex items-center gap-2" key={index}>
										<Radio
											className="text-[#7777E7] focus:ring-[#7777E7]"
											id={action.id}
											name="bulkAction"
											value={action.id}
											checked={localActionSelect === action.id}
										/>
										<Label htmlFor={action.id} className="text-sm font-[400] font-inter">
											{action.label}
										</Label>
									</div>
								))}
							</fieldset>
							<Button
								type="submit"
								color="purplePlaced"
								className="bg-[#7777E7] w-full mt-[24px]"
								isProcessing={markAttendanceMutation.isLoading}
								disabled={!localActionSelect || markAttendanceMutation.isLoading}
							>
								{actions?.find(action => action.id === localActionSelect)?.label || 'Select'}
							</Button>
						</form>
					</>
				);
		}
	};

	return !showModalUi ? (
		<div className="flex items-center gap-2 flex-wrap justify-center">
			{actions
				?.filter(action => !action?.hide)
				.map((action, index) => (
					<Button
						size="sm"
						key={index}
						color="light"
						isProcessing={action.isProcessing}
						disabled={!bulkSelectedCompanies.length || action.isProcessing}
						className="focus:ring-[1px] focus:ring-gray-400"
						onClick={action.onClick}
					>
						{action.label}
					</Button>
				))}
		</div>
	) : (
		<>
			<div className="px-2">
				<div className="h-[1px] bg-[#EBEBF0] my-[12px]"></div>
			</div>

			<div className="px-2 pb-4">{getBulkActionForm()}</div>
		</>
	);
};

export default DrivePositionsBulkAction;
